import { useEffect, useState } from "react";

export function useReportHash() {
  const [reportIdFromHash, setReportIdFromHash] = useState<string | null>(null);

  useEffect(() => {
    const parseHash = () => {
      const m = window.location.hash.match(/^#\/rapport\/([^/?#]+)/i);
      setReportIdFromHash(m ? decodeURIComponent(m[1]) : null);
    };
    parseHash();
    window.addEventListener("hashchange", parseHash);
    return () => window.removeEventListener("hashchange", parseHash);
  }, []);

  return reportIdFromHash;
}
